import { useQuery } from '@tanstack/react-query';
import { currencyApi } from '../services/api';

/**
 * Récupère le taux from→EUR (cache 1h serveur + 30 min côté front).
 * Renvoie un résultat même si from === EUR (rate: 1, source: 'live').
 */
export function useCurrencyRate(from: string | null | undefined) {
  return useQuery({
    queryKey: ['currency-rate', from?.toUpperCase() ?? 'EUR'],
    queryFn: () => currencyApi.rate((from ?? 'EUR').toUpperCase()),
    enabled: Boolean(from),
    staleTime: 30 * 60_000,
  });
}
